import appsettings from "@/store/app-settings";
import { axiosPost } from "@/store/api/axiosUtils.js";
import axios from "axios";

// OTHER
const GetOther_ProvinceName = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetOther_ProvinceName",
    params
  );
};

// LINE CHART
// ===============
const GetLineChart_ComplaintPerMonth = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetLineChart_ComplaintPerMonth",
    params
  );
};

// PIE CHART
// ===============
const GetPieChart_WebService = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetPieChart_WebService",
    params
  );
};
// const GetPieChart_ContinueAndTerminateStatus = (params) => {
//   return axiosPost(
//     appsettings.ocpbComplaintAPIUrl +
//       "api/Dashboard/GetPieChart_ContinueAndTerminateStatus",
//     params
//   );
// };
const GetPieChart_ResultsTheLegalDeptInquiry = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_ResultsTheLegalDeptInquiry",
    params
  );
};
const GetPieChart_ComplaintSendToOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_ComplaintSendToOfficer",
    params
  );
}; 
const GetPieChart_TrackingComplaintStatus = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_TrackingComplaintStatus",
    params
  ); 
}; 
const GetPieChart_DocumentStatusForOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_DocumentStatusForOfficer",
    params
  ); 
};
const GetPieChart_ComplaintSendToOutSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_ComplaintSendToOutSiteDepartment",
    params
  ); 
};

// BAR CHART
// ===============
const GetBarChart_ComplaintSendToOutSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_ComplaintSendToOutSiteDepartment",
    params
  );
};
const GetBarChart_ComplaintSendToInSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_ComplaintSendToInSiteDepartment",
    params
  );
}; 
// const GetBarChart_WaitingToBeSigned = (params) => {
//   return axiosPost(
//     appsettings.ocpbComplaintAPIUrl +
//       "api/Dashboard/GetBarChart_WaitingToBeSigned",
//     params
//   );
// }; 
const GetBarChart_DocumentStatusForLeader = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_DocumentStatusForLeader",
    params
  ); 
};

// BOX CHART
// ===============
const GetBoxChart_SummaryComplaint = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryComplaint",
    params
  );
};
const GetBoxChart_SummaryWebService = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryWebService",
    params
  );
};
const GetBoxChart_SummaryRequestAdditionalDocument = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryRequestAdditionalDocument",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOutSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOutSiteDepartment",
    params
  );
};
const GetBoxChart_SummaryComplaintTerminate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintTerminate",
    params
  );
};
const GetBoxChart_SummaryComplaintReturnToOriginalDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintReturnToOriginalDepartment",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToInSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToInSiteDepartment",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOfficer",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForOfficer",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForLeader = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForLeader",
    params
  );
}; 
const GetBoxChart_SummaryComplaintSendToCenter = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToCenter",
    params
  );
}; 
const GetBoxChart_SummaryComplaint_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryComplaint_Details",
    params
  );
};
const GetBoxChart_SummaryWebService_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryWebService_Details",
    params
  );
};
const GetBoxChart_SummaryRequestAdditionalDocument_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryRequestAdditionalDocument_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOutSiteDepartment_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOutSiteDepartment_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintTerminate_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintTerminate_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintReturnToOriginalDepartment_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintReturnToOriginalDepartment_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToInSiteDepartment_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToInSiteDepartment_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOfficer_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOfficer_Details",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForOfficer_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForOfficer_Details",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForLeader_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForLeader_Details",
    params
  );
}; 
const GetBoxChart_SummaryComplaintSendToCenter_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToCenter_Details",
    params
  );
};
const GetBoxChart_SummaryScreeningValidDetails = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + 
      "api/Dashboard/FasttrackRole/Screening/BoxChart/SummaryScreeningValid/Details",
      params
  );
};
const GetBoxChart_SummaryAdminComplaintFromScreening = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + 
      "api/Dashboard/FasttrackRole/Admin/Charts/SummaryAdminComplaintFromScreening/Details",
      params
  );
};
const GetBoxChart_SummaryOfficerComplaintIncomeDetails = params => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + 
      "api/Dashboard/FasttrackRole/Officer/BoxChart/SummaryOfficerComplaintIncome/Details",
      params
  );
};
const GetBoxChart_SummaryOfficerComplaintMouIncomeDetails = params => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + 
      "api/Dashboard/FasttrackRole/Officer/Charts/SummaryOfficerComplaintMouIncome/Details",
      params
  );
}


// FASTTRACK
const GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany",
    params
  );
}; 
const GetBarChart_SummaryFasttrackTransactionUser = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_SummaryFasttrackTransactionUser",
    params
  );
}; 
const GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany",
    params
  );
};
// FASTTRACK



// FASTTRACK ROLE
const BasePathFasttrackRole = "api/Dashboard/FasttrackRole"

// Screening
const ScreeningBoxChartsSummaryValid = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Screening/BoxChart/SummaryScreeningValid`,
    params
  );
};
const ScreeningTableChartsSummarySending = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Screening/TableChart/SummaryScreeningSending`,
    params
  );
};
// drill-down ของ table chart: params.Mode = "COMPANY" | "DEPARTMENT", params.TargetId = id ที่คลิก
const ScreeningTableChartSendingDetails = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Screening/TableChart/SummaryScreeningSending/Details`,
    params
  );
};
const ScreeningPieChartSummaryOverview = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Screening/PieChart/SummaryScreeningOverview`,
    params
  );
};

// Admin
const AdminChartsSummaryComplaintFromScreening = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Admin/Charts/SummaryAdminComplaintFromScreening`,
    params
  );
};
// drill-down ของตาราง 1: params.TargetId = CompanyId ที่คลิก
const AdminChartsSummaryComplaintFromScreeningCompanyDetails = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Admin/Charts/SummaryAdminComplaintFromScreening/Company/Details`,
    params
  );
};
const AdminTableChartSentOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Admin/TableChart/SummaryAdminComplaintSentOfficer`,
    params
  );
};
// drill-down ของตาราง 2: params.TargetId = OfficerId ที่คลิก
const AdminTableChartSentOfficerDetails = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Admin/TableChart/SummaryAdminComplaintSentOfficer/Details`,
    params
  );
};
const AdminPieChartComplaintOverview = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Admin/PieChart/SummaryAdminComplaintOverview`,
    params
  );
};

// Officer
const OfficerBoxChartComplaintIncome = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Officer/BoxChart/SummaryOfficerComplaintIncome`,
    params
  );
};
const OfficerChartsComplaintMouIncome = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Officer/Charts/SummaryOfficerComplaintMouIncome`,
    params
  );
};
const OfficerBarChartTerminateFromFasttrack = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Officer/BarChart/SummaryOfficerTerminateFromFasttrack`,
    params
  );
};
const OfficerTableChartyComplaintUnderOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Officer/TableChart/SummaryComplaintUnderOfficer`,
    params
  );
};
// drill-down ของตาราง 2 หน้าเจ้าหน้าที่: params.Mode = ชื่อสถานะที่คลิก
const OfficerTableChartyComplaintUnderOfficerDetails = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `${BasePathFasttrackRole}/Officer/TableChart/SummaryComplaintUnderOfficer/Details`,
    params
  );
};
const TableChartComplaintFromOCPB = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `api/Dashboard/Fasttrack/TableChart/ComplaintFrom/Ocpb`,
    params
  );
};
const TableChartComplaintStatusOverview = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + `api/Dashboard/Fasttrack/TableChart/ComplaintStatus/Overview`,
    params
  );
};
export {
  // OTHER
  // ===============
  GetOther_ProvinceName,
  // LINE CHART
  // ===============
  GetLineChart_ComplaintPerMonth,
  // PIE CHART
  // ===============
  GetPieChart_WebService,
  // GetPieChart_ContinueAndTerminateStatus,
  GetPieChart_ResultsTheLegalDeptInquiry,
  GetPieChart_ComplaintSendToOfficer,
  GetPieChart_TrackingComplaintStatus,
  GetPieChart_DocumentStatusForOfficer,
  GetPieChart_ComplaintSendToOutSiteDepartment,
  // BAR CHART
  // ===============
  GetBarChart_ComplaintSendToInSiteDepartment,
  GetBarChart_ComplaintSendToOutSiteDepartment,
  // GetBarChart_WaitingToBeSigned,
  GetBarChart_DocumentStatusForLeader,
  // BOX CHART
  // ===============
  GetBoxChart_SummaryComplaint,
  GetBoxChart_SummaryWebService,
  GetBoxChart_SummaryRequestAdditionalDocument,
  GetBoxChart_SummaryComplaintSendToOutSiteDepartment,
  GetBoxChart_SummaryComplaintSendToInSiteDepartment,
  GetBoxChart_SummaryComplaintTerminate,
  GetBoxChart_SummaryComplaintReturnToOriginalDepartment,
  GetBoxChart_SummaryComplaintSendToOfficer,
  GetBoxChart_SummaryDocumentWaitingApproveForOfficer,
  GetBoxChart_SummaryDocumentWaitingApproveForLeader,
  GetBoxChart_SummaryComplaintSendToCenter,
  GetBoxChart_SummaryScreeningValidDetails,
  GetBoxChart_SummaryAdminComplaintFromScreening,
  GetBoxChart_SummaryOfficerComplaintIncomeDetails,
  GetBoxChart_SummaryOfficerComplaintMouIncomeDetails,
  // BOX CHART DETAILS
  // ===============
  GetBoxChart_SummaryComplaint_Details,
  GetBoxChart_SummaryWebService_Details,
  GetBoxChart_SummaryRequestAdditionalDocument_Details,
  GetBoxChart_SummaryComplaintSendToOutSiteDepartment_Details,
  GetBoxChart_SummaryComplaintSendToInSiteDepartment_Details,
  GetBoxChart_SummaryComplaintTerminate_Details,
  GetBoxChart_SummaryComplaintReturnToOriginalDepartment_Details,
  GetBoxChart_SummaryComplaintSendToOfficer_Details,
  GetBoxChart_SummaryDocumentWaitingApproveForOfficer_Details,
  GetBoxChart_SummaryDocumentWaitingApproveForLeader_Details,
  GetBoxChart_SummaryComplaintSendToCenter_Details,
  // FASTTRACK
  // ===============
  GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany,
  GetBarChart_SummaryFasttrackTransactionUser,
  GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany
  ,TableChartComplaintFromOCPB
  ,TableChartComplaintStatusOverview

  // FASTTRACK ROLE
  // ==============
  ,ScreeningBoxChartsSummaryValid
  ,ScreeningTableChartsSummarySending
  ,ScreeningTableChartSendingDetails
  ,ScreeningPieChartSummaryOverview

  ,AdminChartsSummaryComplaintFromScreening
  ,AdminChartsSummaryComplaintFromScreeningCompanyDetails
  ,AdminTableChartSentOfficer
  ,AdminTableChartSentOfficerDetails
  ,AdminPieChartComplaintOverview

  ,OfficerBoxChartComplaintIncome
  ,OfficerChartsComplaintMouIncome
  ,OfficerBarChartTerminateFromFasttrack
  ,OfficerTableChartyComplaintUnderOfficer
  ,OfficerTableChartyComplaintUnderOfficerDetails
};